// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/bgcupidnew.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Guest Info Form - Clean Cupid Style */

.guest-info-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf5 100%);
  transition: all 0.5s ease;
  margin: 0;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.guest-info-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: -1;
}

.guest-info-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  height: calc(100vh - 64px);
  width: 100%;
  padding: 0 2rem;
  margin: 0 auto;
  box-sizing: border-box;
  max-width: 1400px;
  gap: 2rem;
}

/* Left Avatar Section */
.avatar-section {
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: sticky;
  top: 2rem;
  height: -moz-fit-content;
  height: fit-content;
}

.sol-avatar {
  position: relative;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sol-avatar img {
  width: 150px;
  height: 150px;
  object-fit: contain;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  padding: 12px;
  box-shadow: 0 10px 25px rgba(102, 22, 205, 0.15);
  transition: transform 0.3s ease, filter 0.3s ease;
}

.sol-avatar.talking img {
  animation: talking 0.5s infinite alternate;
  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.5));
}

.sol-avatar.listening img {
  animation: pulse 1.5s infinite alternate;
  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.4));
}

.sol-avatar.thinking img {
  filter: drop-shadow(0 0 20px rgba(102, 22, 205, 0.6));
  animation: thinking 2s infinite;
}

.sol-avatar.happy img {
  transform: scale(1.1);
  filter: drop-shadow(0 0 25px rgba(102, 22, 205, 0.8));
  animation: happy 1s infinite alternate;
}

@keyframes pulse {
  0% { transform: scale(1); }
  100% { transform: scale(1.05); }
}

@keyframes talking {
  0% { transform: scale(1); }
  100% { transform: scale(1.02); }
}

@keyframes thinking {
  0% { transform: rotate(-2deg); }
  50% { transform: rotate(2deg); }
  100% { transform: rotate(-2deg); }
}

@keyframes happy {
  0% { transform: scale(1.1) rotate(-1deg); }
  100% { transform: scale(1.1) rotate(1deg); }
}

/* Progress Bar - Clean */
.progress-container {
  width: 100%;
  max-width: 250px;
  text-align: center;
  margin-bottom: 1rem;
}

.progress-bar {
  width: 100%;
  height: 4px;
  background: rgba(102, 22, 205, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(45deg, #6616cd, #9900ff);
  border-radius: 10px;
  transition: width 0.5s ease;
}

.progress-text {
  color: #6616cd;
  font-size: 0.8rem;
  font-weight: 500;
}

/* Right Content Section */
.right-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 2rem 1rem;
  max-width: 700px;
  height: calc(100vh - 64px);
  overflow-y: auto;
  position: relative;
  margin-top: 1rem;
}

/* Answered Questions Stack */
.answered-questions-stack {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  max-height: 40vh;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.answered-questions-stack::-webkit-scrollbar {
  width: 4px;
}

.answered-questions-stack::-webkit-scrollbar-track {
  background: rgba(102, 22, 205, 0.1);
  border-radius: 10px;
}

.answered-questions-stack::-webkit-scrollbar-thumb {
  background: rgba(102, 22, 205, 0.3);
  border-radius: 10px;
}

.answered-question-dumble {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(102, 22, 205, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.2s ease;
  position: relative;
}

.answered-question-dumble::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(45deg, #6616cd, #9900ff);
  border-radius: 12px 12px 0 0;
}

.answered-question-dumble:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.dumble-icon {
  font-size: 1.2rem;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(45deg, #6616cd, #9900ff);
  border-radius: 50%;
  flex-shrink: 0;
  color: white;
}

.dumble-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.dumble-label {
  font-size: 0.7rem;
  color: #666;
  font-weight: 500;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dumble-value {
  font-size: 0.9rem;
  color: #333;
  font-weight: 600;
  line-height: 1.2;
  word-break: break-word;
}

/* Current Question Section */
.current-question-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.greeting {
  font-family: "Syne", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #6616cd;
  text-align: left;
}

.instructions {
  font-family: "Syne", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  text-align: left;
  color: #444;
  line-height: 1.4;
  min-height: 2em;
}

.typing-cursor {
  color: #6616cd;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

.question-tip {
  background: linear-gradient(45deg, #6616cd, #9900ff);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 1rem;
  line-height: 1.3;
  margin-top: 1rem;
}

/* Input Section */
.input-container {
  width: 100%;
  margin-bottom: 1.5rem;
}

.input-with-voice {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.form-input {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid rgba(102, 22, 205, 0.2);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  color: #333;
  transition: all 0.3s ease;
  outline: none;
  font-family: inherit;
  width: 100%;
}

.form-input:focus {
  border-color: #6616cd;
  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);
  background: white;
}

/* React Select */
.react-select-container {
  flex: 1 1;
}

.react-select__control {
  min-height: 44px !important;
  border-radius: 8px !important;
  border: 2px solid rgba(102, 22, 205, 0.2) !important;
  background: rgba(255, 255, 255, 0.9) !important;
}

.react-select__control--is-focused {
  border-color: #6616cd !important;
  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1) !important;
}

.react-select__menu {
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
  z-index: 9999 !important;
}

.react-select__option {
  padding: 8px 12px !important;
  font-size: 0.9rem !important;
}

.react-select__option--is-selected {
  background-color: #6616cd !important;
}

.react-select__option--is-focused {
  background-color: rgba(102, 22, 205, 0.1) !important;
}

/* Voice Button */
.voice-button {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(45deg, #6616cd, #9900ff);
  border: none;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(102, 22, 205, 0.2);
  flex-shrink: 0;
}

.voice-button:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.3);
  transform: translateY(-1px);
}

.voice-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.voice-button.recording {
  background: linear-gradient(135deg, #dc3545, #c82333);
  animation: record-pulse 1s ease-in-out infinite;
}

.voice-button.processing {
  background: linear-gradient(135deg, #ffc107, #e0a800);
}

@keyframes record-pulse {
  0%, 100% { box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3); }
  50% { box-shadow: 0 4px 16px rgba(220, 53, 69, 0.5); }
}

/* Button Group */
.button-group {
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  margin-top: 1rem;
}

.next-button {
  background: linear-gradient(45deg, #6616cd, #9900ff);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 8px rgba(102, 22, 205, 0.2);
  min-width: 120px;
  justify-content: center;
}

.next-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.3);
}

.next-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.button-arrow {
  font-size: 0.9rem;
  transition: transform 0.3s ease;
}

.next-button:hover .button-arrow {
  transform: translateX(2px);
}

/* Completion Animation */
.completion-animation {
  text-align: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(102, 22, 205, 0.1);
}

.completion-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #28a745;
}

.completion-text {
  font-size: 1.2rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 1rem;
}

.loading-dots img {
  width: 28px;
  height: 28px;
  opacity: 0.8;
}



/* Responsive Design */
@media (max-width: 1200px) {
  .guest-info-content {
    padding: 0 1.5rem;
    gap: 1.5rem;
  }

  .avatar-section {
    flex: 0 0 250px;
  }

  .sol-avatar img {
    width: 120px;
    height: 120px;
  }
}

@media (max-width: 992px) {
  .guest-info-container {
    height: auto;
    min-height: 100vh;
    overflow-y: auto;
  }

  .guest-info-content {
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    height: auto;
    min-height: calc(100vh - 64px);
    gap: 1rem;
  }

  .avatar-section {
    flex: none;
    position: static;
    margin-bottom: 0;
    transform: scale(0.8);
  }

  .right-content {
    padding: 1rem 0.5rem;
    height: auto;
    max-width: 100%;
  }

  .answered-questions-stack {
    max-height: 30vh;
  }
}

@media (max-width: 768px) {
  .guest-info-content {
    padding: 0.5rem;
  }

  .avatar-section {
    transform: scale(0.7);
  }

  .right-content {
    padding: 0.5rem 0.25rem;
  }

  .greeting {
    font-size: 1.3rem;
  }

  .instructions {
    font-size: 0.9rem;
  }

  .answered-question-dumble {
    padding: 0.75rem 1rem;
    gap: 0.75rem;
  }

  .dumble-icon {
    width: 30px;
    height: 30px;
    font-size: 1rem;
  }

  .dumble-value {
    font-size: 0.85rem;
  }

  .form-input {
    font-size: 0.9rem;
    padding: 0.65rem 0.85rem;
  }

  .input-with-voice {
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
  }

  .voice-button {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .next-button {
    padding: 0.65rem 1.25rem;
    font-size: 0.9rem;
  }

  .button-group {
    justify-content: center;
  }

  .answered-questions-stack {
    max-height: 25vh;
  }
}

@media (max-width: 480px) {
  .guest-info-content {
    padding: 0.25rem;
  }
  
  .right-content {
    padding: 0.25rem;
  }
  
  .greeting {
    font-size: 1.2rem;
    margin-bottom: 0.25rem;
  }

  .instructions {
    font-size: 0.85rem;
    margin-bottom: 1rem;
  }

  .answered-question-dumble {
    padding: 0.6rem 0.8rem;
  }

  .dumble-icon {
    width: 28px;
    height: 28px;
    font-size: 0.9rem;
  }

  .dumble-value {
    font-size: 0.8rem;
  }
  
  .form-input {
    font-size: 0.85rem;
    padding: 0.6rem 0.8rem;
  }

  .input-with-voice {
    max-width: 100%;
  }
  
  .voice-button {
    width: 36px;
    height: 36px;
    font-size: 0.9rem;
  }

  .answered-questions-stack {
    max-height: 30vh;
  }
}

/* Utility Classes */
.fade-up {
  animation: fadeUp 0.5s ease-out;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.avatar-bounce {
  animation: bounce 1s ease;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .sol-avatar.talking img,
  .sol-avatar.listening img,
  .sol-avatar.thinking img,
  .sol-avatar.happy img {
    animation: none;
  }
  
  .answered-question-dumble:hover {
    transform: none;
}

  .next-button:hover:not(:disabled),
  .voice-button:hover:not(:disabled) {
    transform: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/Authentication/GuestInfoForm.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,kHAAkH;AACpH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,OAAO,sBAAsB,EAAE;AACjC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,OAAO,sBAAsB,EAAE;AACjC;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,MAAM,uBAAuB,EAAE;EAC/B,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,KAAK,mCAAmC,EAAE;EAC1C,OAAO,kCAAkC,EAAE;AAC7C;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,SAAO;AACT;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oDAAoD;EACpD,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,oDAAoD;EACpD,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;AACtD;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,WAAW,4CAA4C,EAAE;EACzD,MAAM,6CAA6C,EAAE;AACvD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;;;AAIA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,kBAAkB;AAClB;EACE;;;;IAIE,eAAe;EACjB;;EAEA;IACE,eAAe;AACnB;;EAEE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Guest Info Form - Clean Cupid Style */\n\n.guest-info-container {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf5 100%);\n  transition: all 0.5s ease;\n  margin: 0;\n  padding: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n}\n\n.guest-info-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(\"../../assets/bgcupidnew.png\");\n  background-size: cover;\n  background-position: center;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.guest-info-content {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  height: calc(100vh - 64px);\n  width: 100%;\n  padding: 0 2rem;\n  margin: 0 auto;\n  box-sizing: border-box;\n  max-width: 1400px;\n  gap: 2rem;\n}\n\n/* Left Avatar Section */\n.avatar-section {\n  flex: 0 0 300px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: sticky;\n  top: 2rem;\n  height: fit-content;\n}\n\n.sol-avatar {\n  position: relative;\n  margin-bottom: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.sol-avatar img {\n  width: 150px;\n  height: 150px;\n  object-fit: contain;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 12px;\n  box-shadow: 0 10px 25px rgba(102, 22, 205, 0.15);\n  transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n.sol-avatar.talking img {\n  animation: talking 0.5s infinite alternate;\n  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.5));\n}\n\n.sol-avatar.listening img {\n  animation: pulse 1.5s infinite alternate;\n  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.4));\n}\n\n.sol-avatar.thinking img {\n  filter: drop-shadow(0 0 20px rgba(102, 22, 205, 0.6));\n  animation: thinking 2s infinite;\n}\n\n.sol-avatar.happy img {\n  transform: scale(1.1);\n  filter: drop-shadow(0 0 25px rgba(102, 22, 205, 0.8));\n  animation: happy 1s infinite alternate;\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  100% { transform: scale(1.05); }\n}\n\n@keyframes talking {\n  0% { transform: scale(1); }\n  100% { transform: scale(1.02); }\n}\n\n@keyframes thinking {\n  0% { transform: rotate(-2deg); }\n  50% { transform: rotate(2deg); }\n  100% { transform: rotate(-2deg); }\n}\n\n@keyframes happy {\n  0% { transform: scale(1.1) rotate(-1deg); }\n  100% { transform: scale(1.1) rotate(1deg); }\n}\n\n/* Progress Bar - Clean */\n.progress-container {\n  width: 100%;\n  max-width: 250px;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 4px;\n  background: rgba(102, 22, 205, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(45deg, #6616cd, #9900ff);\n  border-radius: 10px;\n  transition: width 0.5s ease;\n}\n\n.progress-text {\n  color: #6616cd;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n/* Right Content Section */\n.right-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 2rem 1rem;\n  max-width: 700px;\n  height: calc(100vh - 64px);\n  overflow-y: auto;\n  position: relative;\n  margin-top: 1rem;\n}\n\n/* Answered Questions Stack */\n.answered-questions-stack {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  max-height: 40vh;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n}\n\n.answered-questions-stack::-webkit-scrollbar {\n  width: 4px;\n}\n\n.answered-questions-stack::-webkit-scrollbar-track {\n  background: rgba(102, 22, 205, 0.1);\n  border-radius: 10px;\n}\n\n.answered-questions-stack::-webkit-scrollbar-thumb {\n  background: rgba(102, 22, 205, 0.3);\n  border-radius: 10px;\n}\n\n.answered-question-dumble {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(102, 22, 205, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.answered-question-dumble::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(45deg, #6616cd, #9900ff);\n  border-radius: 12px 12px 0 0;\n}\n\n.answered-question-dumble:hover {\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.dumble-icon {\n  font-size: 1.2rem;\n  width: 35px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(45deg, #6616cd, #9900ff);\n  border-radius: 50%;\n  flex-shrink: 0;\n  color: white;\n}\n\n.dumble-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.dumble-label {\n  font-size: 0.7rem;\n  color: #666;\n  font-weight: 500;\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dumble-value {\n  font-size: 0.9rem;\n  color: #333;\n  font-weight: 600;\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n/* Current Question Section */\n.current-question-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.greeting {\n  font-family: \"Syne\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n  color: #6616cd;\n  text-align: left;\n}\n\n.instructions {\n  font-family: \"Syne\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1rem;\n  margin-bottom: 1.5rem;\n  text-align: left;\n  color: #444;\n  line-height: 1.4;\n  min-height: 2em;\n}\n\n.typing-cursor {\n  color: #6616cd;\n  animation: blink 1s infinite;\n}\n\n@keyframes blink {\n  0%, 50% { opacity: 1; }\n  51%, 100% { opacity: 0; }\n}\n\n.question-tip {\n  background: linear-gradient(45deg, #6616cd, #9900ff);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  line-height: 1.3;\n  margin-top: 1rem;\n}\n\n/* Input Section */\n.input-container {\n  width: 100%;\n  margin-bottom: 1.5rem;\n}\n\n.input-with-voice {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.form-input {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.9);\n  border: 2px solid rgba(102, 22, 205, 0.2);\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n  color: #333;\n  transition: all 0.3s ease;\n  outline: none;\n  font-family: inherit;\n  width: 100%;\n}\n\n.form-input:focus {\n  border-color: #6616cd;\n  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);\n  background: white;\n}\n\n/* React Select */\n.react-select-container {\n  flex: 1;\n}\n\n.react-select__control {\n  min-height: 44px !important;\n  border-radius: 8px !important;\n  border: 2px solid rgba(102, 22, 205, 0.2) !important;\n  background: rgba(255, 255, 255, 0.9) !important;\n}\n\n.react-select__control--is-focused {\n  border-color: #6616cd !important;\n  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1) !important;\n}\n\n.react-select__menu {\n  border-radius: 8px !important;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;\n  z-index: 9999 !important;\n}\n\n.react-select__option {\n  padding: 8px 12px !important;\n  font-size: 0.9rem !important;\n}\n\n.react-select__option--is-selected {\n  background-color: #6616cd !important;\n}\n\n.react-select__option--is-focused {\n  background-color: rgba(102, 22, 205, 0.1) !important;\n}\n\n/* Voice Button */\n.voice-button {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: linear-gradient(45deg, #6616cd, #9900ff);\n  border: none;\n  color: white;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(102, 22, 205, 0.2);\n  flex-shrink: 0;\n}\n\n.voice-button:hover:not(:disabled) {\n  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.3);\n  transform: translateY(-1px);\n}\n\n.voice-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.voice-button.recording {\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  animation: record-pulse 1s ease-in-out infinite;\n}\n\n.voice-button.processing {\n  background: linear-gradient(135deg, #ffc107, #e0a800);\n}\n\n@keyframes record-pulse {\n  0%, 100% { box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3); }\n  50% { box-shadow: 0 4px 16px rgba(220, 53, 69, 0.5); }\n}\n\n/* Button Group */\n.button-group {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-start;\n  margin-top: 1rem;\n}\n\n.next-button {\n  background: linear-gradient(45deg, #6616cd, #9900ff);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 2px 8px rgba(102, 22, 205, 0.2);\n  min-width: 120px;\n  justify-content: center;\n}\n\n.next-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.3);\n}\n\n.next-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.button-arrow {\n  font-size: 0.9rem;\n  transition: transform 0.3s ease;\n}\n\n.next-button:hover .button-arrow {\n  transform: translateX(2px);\n}\n\n/* Completion Animation */\n.completion-animation {\n  text-align: center;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(102, 22, 205, 0.1);\n}\n\n.completion-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  color: #28a745;\n}\n\n.completion-text {\n  font-size: 1.2rem;\n  color: #333;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.loading-dots img {\n  width: 28px;\n  height: 28px;\n  opacity: 0.8;\n}\n\n\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .guest-info-content {\n    padding: 0 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .avatar-section {\n    flex: 0 0 250px;\n  }\n\n  .sol-avatar img {\n    width: 120px;\n    height: 120px;\n  }\n}\n\n@media (max-width: 992px) {\n  .guest-info-container {\n    height: auto;\n    min-height: 100vh;\n    overflow-y: auto;\n  }\n\n  .guest-info-content {\n    flex-direction: column;\n    align-items: center;\n    padding: 1rem;\n    height: auto;\n    min-height: calc(100vh - 64px);\n    gap: 1rem;\n  }\n\n  .avatar-section {\n    flex: none;\n    position: static;\n    margin-bottom: 0;\n    transform: scale(0.8);\n  }\n\n  .right-content {\n    padding: 1rem 0.5rem;\n    height: auto;\n    max-width: 100%;\n  }\n\n  .answered-questions-stack {\n    max-height: 30vh;\n  }\n}\n\n@media (max-width: 768px) {\n  .guest-info-content {\n    padding: 0.5rem;\n  }\n\n  .avatar-section {\n    transform: scale(0.7);\n  }\n\n  .right-content {\n    padding: 0.5rem 0.25rem;\n  }\n\n  .greeting {\n    font-size: 1.3rem;\n  }\n\n  .instructions {\n    font-size: 0.9rem;\n  }\n\n  .answered-question-dumble {\n    padding: 0.75rem 1rem;\n    gap: 0.75rem;\n  }\n\n  .dumble-icon {\n    width: 30px;\n    height: 30px;\n    font-size: 1rem;\n  }\n\n  .dumble-value {\n    font-size: 0.85rem;\n  }\n\n  .form-input {\n    font-size: 0.9rem;\n    padding: 0.65rem 0.85rem;\n  }\n\n  .input-with-voice {\n    flex-direction: row;\n    gap: 0.5rem;\n    align-items: center;\n  }\n\n  .voice-button {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n\n  .next-button {\n    padding: 0.65rem 1.25rem;\n    font-size: 0.9rem;\n  }\n\n  .button-group {\n    justify-content: center;\n  }\n\n  .answered-questions-stack {\n    max-height: 25vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .guest-info-content {\n    padding: 0.25rem;\n  }\n  \n  .right-content {\n    padding: 0.25rem;\n  }\n  \n  .greeting {\n    font-size: 1.2rem;\n    margin-bottom: 0.25rem;\n  }\n\n  .instructions {\n    font-size: 0.85rem;\n    margin-bottom: 1rem;\n  }\n\n  .answered-question-dumble {\n    padding: 0.6rem 0.8rem;\n  }\n\n  .dumble-icon {\n    width: 28px;\n    height: 28px;\n    font-size: 0.9rem;\n  }\n\n  .dumble-value {\n    font-size: 0.8rem;\n  }\n  \n  .form-input {\n    font-size: 0.85rem;\n    padding: 0.6rem 0.8rem;\n  }\n\n  .input-with-voice {\n    max-width: 100%;\n  }\n  \n  .voice-button {\n    width: 36px;\n    height: 36px;\n    font-size: 0.9rem;\n  }\n\n  .answered-questions-stack {\n    max-height: 30vh;\n  }\n}\n\n/* Utility Classes */\n.fade-up {\n  animation: fadeUp 0.5s ease-out;\n}\n\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.avatar-bounce {\n  animation: bounce 1s ease;\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-20px);\n  }\n  60% {\n    transform: translateY(-10px);\n  }\n}\n\n/* Accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .sol-avatar.talking img,\n  .sol-avatar.listening img,\n  .sol-avatar.thinking img,\n  .sol-avatar.happy img {\n    animation: none;\n  }\n  \n  .answered-question-dumble:hover {\n    transform: none;\n}\n\n  .next-button:hover:not(:disabled),\n  .voice-button:hover:not(:disabled) {\n    transform: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
